import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../Component/CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <header>
      {/* Promotional Banner */}
      <div className="promo-banner">FREE 4/11 CREAM SOAP WITH ORDERS $125+</div>

      {/* Main Header */}
      <div className="main-header">
        <div className="header-container">
          {/* Logo */}
          <div className="logo-container">
            <Link to="/" onClick={toTop}>
              <div className="logo-icon">S</div>
              <div className="logo-text">
                <div className="brand-name">Sadiemall</div>
                <div className="brand-tagline">modern apothecary</div>
              </div>
            </Link>
          </div>

          {/* Right Icons */}
          <div className="header-icons">
            <Link to="/cartpage" className="icon-link cart-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              {totalItems > 0 && (
                <span className="cart-badge">{totalItems}</span>
              )}
            </Link>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="navigation">
        <div className="nav-container">
          <div className="nav-links">
            <Link to="/shop" onClick={toTop}>
              BEST SELLERS
            </Link>
            <Link to="/about" onClick={toTop}>
              About
            </Link>
            <Link to="/contact" onClick={toTop}>
              Contact Us
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
